import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

// Styled component for the label that will float above the upload box
const FloatingLabel = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '-10px',
  left: '10px',
  fontSize: '12px',
  padding: '0 5px',
  backgroundColor: '#fff',
  zIndex: 1,
  color: '#666',
}));

// Styled component for the container that will hold both the label and upload box
const UploadContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  marginTop: '10px',
}));

const UploadBox = styled(Box)(({ theme }) => ({
  border: "1px dashed #ccc",
  borderRadius: "4px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  backgroundColor: "#FBFBFF",
  height: "150px",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
}));

const FileUploader = ({ onFileChange }) => {
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    
    const newFiles = selectedFiles.map(file => {
      // Extract filename without extension to use as default title
      const fileName = file.name;
      const fileNameWithoutExtension = fileName.split('.').slice(0, -1).join('.');
      
      return {
        file,
        title: fileNameWithoutExtension || fileName, // Use filename without extension, or full name if no extension
        id: Math.random().toString(36).substring(2, 9)
      };
    });
    
    onFileChange(newFiles);
  };

  return (
    <Grid item xs={12}>
      <UploadContainer>
        <FloatingLabel>Document Upload</FloatingLabel>
        <UploadBox component="label">
          <CloudUploadIcon sx={{ fontSize: 40, color: '#757575', mb: 1 }} />
          <Typography variant="body1">Upload files</Typography>
          <VisuallyHiddenInput
            type="file"
            multiple
            onChange={handleFileChange}
          />
        </UploadBox>
      </UploadContainer>
    </Grid>
  );
};

export default FileUploader;
